import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M55.93 97.82c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#ACB8C3"
      d="M58.43 21.2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.57 76.91a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      d="m27.49 96.81 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM91.5 22.09h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#ACB8C3"
      d="M72.04 83H35.58C29.74 83 25 78.3 25 72.5V41.88c0-4.91 4.01-8.89 8.96-8.89h36.46c5.84 0 10.58 4.7 10.58 10.5v30.62c0 4.91-4.01 8.89-8.96 8.89"
    />
    <path
      fill="#C7D0D9"
      d="M97.68 41.36 81 52.55v12.88l16.84 9.3c1.43.79 3.16-.26 3.16-1.92V43.18c0-1.74-1.9-2.78-3.32-1.82M17.65 46H25v24h-7.35C16.19 70 15 68.64 15 66.97V49.03c0-1.67 1.19-3.03 2.65-3.03M35.2 46h25.59c1.22 0 2.2.97 2.2 2.16v19.68c0 1.19-.99 2.16-2.2 2.16H35.2c-1.22 0-2.2-.97-2.2-2.16V48.16c0-1.19.99-2.16 2.2-2.16"
    />
    <path
      fill="#7B8493"
      d="M70.5 55.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M70.5 65.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
  </svg>
);
const SvgEnrichedIconWebinarGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconWebinarGreyscale);
export default Memo;
